import Component from '@glimmer/component';
import { action } from '@ember/object';
import AditoolsMenuLinks from './aditools-menu-links.ts';
import AditoolsRenderer from '../modifiers/aditools-renderer.ts';
import { fitText } from '../utils/fit-text.ts';

interface AditoolsTightMenubarSignature {
  Element: HTMLMenuElement;
  Args: {
    'tools-title': string;
    setTitleWidth?: () => number;
  };
  Blocks: {
    default: [
      {
        'menu-links': typeof AditoolsMenuLinks;
      },
    ];
  };
}

export default class AditoolsTightMenubar extends Component<AditoolsTightMenubarSignature> {
  headerElement: HTMLElement | null = null;
  menuLinksClass = AditoolsMenuLinks;
  renderer = AditoolsRenderer;
  @action adjustHeaderTitle() {
    if (this.headerElement) {
      const titleElement = this.headerElement as HTMLElement;
      const textContent = titleElement.textContent as string;
      const maxFontSize = 35;
      const minFontSize = 12;
      const titleHeight = this.headerElement.clientHeight;
      const titleWidth = this.args.setTitleWidth ? this.args.setTitleWidth() : this.headerElement.clientWidth;
      const family = window.getComputedStyle(titleElement, null).getPropertyValue('font-family');
      const weight = window.getComputedStyle(titleElement, null).getPropertyValue('font-weight');
      let fontsize = fitText(family, weight, textContent, titleHeight, titleWidth, maxFontSize, minFontSize);
      fontsize = fontsize < minFontSize ? minFontSize : fontsize;
      titleElement.style.width = titleWidth + 'px';
      titleElement.style.minWidth = titleWidth + 'px';
      titleElement.style.fontSize = fontsize + 'px';
      titleElement.style.lineHeight = fontsize + 4 + 'px';
    }
  }

  @action insertResizeListener(element: HTMLElement) {
    if (element) {
      this.headerElement = element;
      this.adjustHeaderTitle();
      addEventListener('resize', this.adjustHeaderTitle);
    }
  }
  @action destroyResizeListener() {
    this.headerElement = null;
    removeEventListener('resize', this.adjustHeaderTitle);
  }
}
